class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if (event.target && !facetForm.contains(event.target)) return;
      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    //const facetTiggers = this.querySelectorAll('.facets__button-show,.facets__container__overlay');
    //if (facetTiggers.length > 0) {
		//	facetTiggers.forEach(trigger => {
		//		trigger.addEventListener('click',()=> {
		//			this.querySelector('.facets__container').classList.toggle('active');
		//			this.querySelector('.facets__container__overlay').classList.toggle('active');
		//			document.body.classList.toggle('overflow-hidden');
		//		});
		//	})
    //}
		this.bindFacetTriggers();

    document.addEventListener('click', (e) => {
      const detailsList = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const details = e.target.closest(".facets__disclosure[open]");

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute("open");
        })
      }
    })

		
  }

	bindFacetTriggers() {
    const facetTriggers = this.querySelectorAll('.facets__button-show, .facets__container__overlay, .close-drawer');
    if (facetTriggers.length > 0) {
      facetTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.querySelector('.facets__container').classList.toggle('active');
          this.querySelector('.facets__container__overlay').classList.toggle('active');
          document.body.classList.toggle('overflow-hidden');
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static beginProductGridPending(container) {
    if (!container || container.dataset.facetGridPending === '1') return;
    container.dataset.facetGridPending = '1';
    const height = container.offsetHeight;
    if (height > 0) container.style.minHeight = `${height}px`;
    container.querySelector('.collection-product, .collection')?.classList.add('loading');
  }

  static endProductGridPending(container) {
    if (!container) return;
    container.removeAttribute('data-facet-grid-pending');
    container.style.removeProperty('min-height');
    container.querySelectorAll('.collection-product.loading, .collection.loading').forEach((el) => {
      el.classList.remove('loading');
    });
  }

 static renderPage(searchParams, event, updateURLHash = true) {
    if (FacetFiltersForm.isSearchPageContext() && typeof window.__clistBeginSearchProductsLoading === 'function') {
      window.__clistBeginSearchProductsLoading();
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const generation = FacetFiltersForm.beginRender();
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && !FacetFiltersForm.isSearchPageContext()) {
      FacetFiltersForm.beginProductGridPending(gridContainer);
    }
    gridContainer?.querySelector('.collection-product, .collection')?.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, generation) :
        FacetFiltersForm.renderSectionFromFetch(url, event, generation);
    });

		document.querySelector('facet-filters-form').bindFacetTriggers();

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    return generation;
  }

 static renderSectionFromFetch(url, event, generation) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        // Drop stale response — a newer filter click has superseded this one.
        if (generation != null && !FacetFiltersForm.isCurrentRender(generation)) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((err) => {
        if (FacetFiltersForm.isSearchPageContext() && typeof window.__clistEndSearchProductsLoading === 'function') {
          window.__clistEndSearchProductsLoading();
        }
        console.error('[facets] renderSectionFromFetch failed', err);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, generation) {
    if (FacetFiltersForm.isSearchPageContext()) {
      const cachedEntry = FacetFiltersForm.filterData.find(filterDataUrl);
      if (cachedEntry) FacetFiltersForm.renderSectionFromFetch(cachedEntry.url, event, generation);
      return;
    }
    if (generation != null && !FacetFiltersForm.isCurrentRender(generation)) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const isSearch = FacetFiltersForm.isSearchPageContext();

    if (isSearch && typeof window.__clistBeginSearchProductsLoading === 'function') {
      window.__clistBeginSearchProductsLoading();
    } else if (container) {
      FacetFiltersForm.beginProductGridPending(container);
    }

    if (isSearch && typeof window.__clistPrepareSearchProductGridHtml === 'function') {
      html = window.__clistPrepareSearchProductGridHtml(html) || html;
    }

    if (typeof window.ClistProductsPlp?.cleanupOrphanedQuickAddModals === 'function') {
      window.ClistProductsPlp.cleanupOrphanedQuickAddModals({ phase: 'before' });
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshContainer = parsed.getElementById('ProductGridContainer');
    if (container && freshContainer) {
      container.innerHTML = freshContainer.innerHTML;
    }

    if (typeof window.ClistProductsPlp?.cleanupOrphanedQuickAddModals === 'function') {
      window.ClistProductsPlp.cleanupOrphanedQuickAddModals({ phase: 'after' });
    }

    if (isSearch && typeof window.__clistFinalizeSearchProductGridRender === 'function') {
      window.__clistFinalizeSearchProductGridRender();
    } else if (container) {
      FacetFiltersForm.endProductGridPending(container);
    }

    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
    const sectionEl = document.getElementById('ProductGridContainer')?.closest('[id^="shopify-section-"]');
    if (sectionEl?.querySelector('.template-search')) {
      window.ClistMobileGridBorders?.scheduleUpdate?.(sectionEl);
      document.dispatchEvent(new CustomEvent('clist:sync-search-column-height'));
    }
  }

  static renderProductCount(html) {
    if (window.ClistProductsPlp?.applyAuthoritativeCountFromHtml) {
      window.ClistProductsPlp.applyAuthoritativeCountFromHtml(html);
      document.getElementById('ProductCount')?.classList.remove('loading');
      document.getElementById('ProductCountDesktop')?.classList.remove('loading');
      return;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.getElementById('ProductCount');
    const matched = source?.getAttribute('data-products-count-matched');
    const reference = source?.getAttribute('data-products-count-reference');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (matched != null && reference != null) {
      const safeReference = Math.max(0, parseInt(reference, 10) || 0);
      let safeMatched = Math.max(0, parseInt(matched, 10) || 0);
      if (safeReference > 0) safeMatched = Math.min(safeMatched, safeReference);
      const text = `Showing ${safeMatched} of ${safeReference} Products`;
      if (container) {
        container.textContent = text;
        container.setAttribute('data-products-count-matched', String(safeMatched));
        container.setAttribute('data-products-count-reference', String(safeReference));
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.textContent = text;
        containerDesktop.setAttribute('data-products-count-matched', String(safeMatched));
        containerDesktop.setAttribute('data-products-count-reference', String(safeReference));
        containerDesktop.classList.remove('loading');
      }
      return;
    }

    const count = source?.innerHTML;
    if (container && count != null) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop && count != null) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static reorderFacetDisplayOrder(root) {
    if (window.ClistFilterOrder && typeof window.ClistFilterOrder.reorderProductFacetsInDom === 'function') {
      window.ClistFilterOrder.reorderProductFacetsInDom(root || document);
    }
    if (window.ClistFilterOrder && typeof window.ClistFilterOrder.applyCanonicalGroupLabelsInDom === 'function') {
      window.ClistFilterOrder.applyCanonicalGroupLabelsInDom(root || document);
    }
  }

  static renderFilters(html, event) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const facetDetailsElements =
    parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
  const matchesIndex = (element) => {
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;
    return jsFilter ? element.dataset.filterParam === jsFilter.dataset.filterParam : false;
  }
  const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
  const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

  facetsToRender.forEach((element) => {
    const targetFilter = document.querySelector(`.js-filter[data-filter-param="${element.dataset.filterParam}"]`);
    if (targetFilter) {
      targetFilter.innerHTML = element.innerHTML;
    }
  });

  FacetFiltersForm.renderActiveFacets(parsedHTML);
  FacetFiltersForm.renderAdditionalElements(parsedHTML);
  document.querySelector('facet-filters-form').bindFacetTriggers();
  if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  FacetFiltersForm.reorderFacetDisplayOrder();
  if (window.ClistProductsPlp?.scheduleSyncProductsSidebarFilterOptions) {
    window.ClistProductsPlp.scheduleSyncProductsSidebarFilterOptions();
  } else if (window.ClistProductsPlp?.syncProductsSidebarFilterOptions) {
    window.ClistProductsPlp.syncProductsSidebarFilterOptions();
  }
}

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    const productsFacetsRoot = document.querySelector('[data-clist-products-facets]');
    const scope = productsFacetsRoot || document;

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = scope.querySelector(selector);
      if (!target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
      const hasPills = target.querySelector('.active-facets__button-inner');
      if (hasPills) {
        target.style.removeProperty('display');
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting','.facets__selected'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.isSearchPageContext = function isSearchPageContext() {
  return Boolean(
    document.querySelector('.template-search') ||
    (typeof window !== 'undefined' &&
      window.location &&
      window.location.pathname &&
      window.location.pathname.indexOf('/search') !== -1)
  );
};

window.FacetFiltersForm = FacetFiltersForm;
FacetFiltersForm.filterData = [];
FacetFiltersForm.__renderGeneration = 0;
FacetFiltersForm.beginRender = function () {
  FacetFiltersForm.__renderGeneration += 1;
  return FacetFiltersForm.__renderGeneration;
};
FacetFiltersForm.isCurrentRender = function (gen) {
  return gen === FacetFiltersForm.__renderGeneration;
};
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.reorderFacetDisplayOrder();
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
